import React from "react";
import { RxCross2 } from "react-icons/rx";
type ModalProps = {
  isOpen: boolean;
  onClose?: () => void;
  size?: 1 | 2 | 3 | 4 | 5;
  children: React.ReactNode;
  showCloseButton?: boolean;
  hideFooter?: boolean;
};

const maxWidthMap: Record<number, string> = {
  1: "max-w-xl",
  2: "max-w-2xl",
  3: "max-w-3xl",
  4: "max-w-4xl",
  5: "max-w-5xl",
};

const Modal: React.FC<ModalProps> = ({
  isOpen,
  onClose,
  size = 1,
  children,
  showCloseButton = true,
  hideFooter = false,
}) => {
  if (!isOpen) return null;

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center bg-black bg-opacity-40">
      <div className={`bg-white rounded-xl w-full p-6 relative ${maxWidthMap[size]}`}>
        {showCloseButton && (
          <button
            onClick={onClose}
            className="absolute top-3 right-4 text-gray-400 hover:text-gray-700 text-2xl font-bold cursor-pointer"
            aria-label="Close modal"
          >
            <RxCross2 />
          </button>
        )}

        <div>{children}</div>

        {!hideFooter && (
          <div className="flex justify-end mt-6 border-t pt-4 border-gray-200">
            <button
              onClick={onClose}
              className="px-4 py-2 text-sm font-medium text-gray-700 bg-gray-100 hover:bg-gray-200 rounded-md cursor-pointer"
            >
              Close
            </button>
          </div>
        )}
      </div>
    </div>
  );
};

export default Modal;
